import { useCallback } from "react";
import { db } from "@client";
import axios from "axios";
import { refreshUserDataQuery } from "@query";
import { useStores } from "./stores";

export const useAutoLogin = () => {
  
  const { userStore } = useStores();
  
  return useCallback(async () => {
    
    const users = await db.user.toArray();
    
    if (!users?.[0]?.token)
      throw "No data";
    
    const { token, board } = users[0];
    axios.defaults.headers.common["Authorization"] = token;
    
    const userData = await refreshUserDataQuery();

    if (userStore.impersonation) {
      userStore.saveUserData(userData, board);
      userStore.setLoginProcessStatus(true);
      return;
    }

    await userStore.checkUserTrial();
    userStore.saveUserData(userData, board);
    userStore.checkWorkspacesAndRedirect();
    userStore.setLoginProcessStatus(true);
  }, []);
}